import {hasParticipantFilterActive} from 'common-data-handling';
import {useFilteredParticipants} from './useFilteredParticipants';
import {useRecommendedParticipantsFilter} from './useRecommendedParticipantsFilter';

/**
 * Returns the recommended participants for a given event based on the filter.
 *
 * @param {Number} eventId - Event identification
 * @return {array} Recommended participants
 */
export function useRecommendedParticipants(eventId) {
    const filter = useRecommendedParticipantsFilter(eventId),
        [participants] = useFilteredParticipants(eventId, filter);

    if (!hasParticipantFilterActive(filter)) return [];

    return participants;
}
